export const STORAGE_KEY = 'jwt_access_token';
export const TAIRRA_STORAGE_KEY = 'jwt_access_token_tairra';
export const EMPLOYEE_ID_KEY = 'employeeId';
export const IS_ADMIN_KEY = 'isAdmin';
export const IS_EMAIL_VERIFIED_KEY = 'isEmailVerified';
export const USER_RIIGHT_PERMISSIN = 'userRightPermission';

export const ROLE_KEY = 'role';
export const EXPIRATION_KEY = 'exp';
export const CLIENT_ID_KEY = 'client_id';